import React, { HTMLAttributes, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from './header'
import Footer from './footer'
import { URLS } from '../_config'
import DashboardTabElement from './dashboardTabElement'
import { trackEvent } from '../_common/functions'
import { useCommonApi } from '../store/api/hooks/commonApiHook'

type tabTypes = 'my-experiment' | 'data-onboarding' | 'glossary' | 'executive-dashboard' | 'sample-size'

interface DashboardLayoutProps extends HTMLAttributes<HTMLDivElement> {
    active: tabTypes
    className?: string
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children, active, className = '' }) => {
    const { t } = useTranslation()
    const conmmonApi = useCommonApi()
    const [productInfo, setProductInfo] = useState<any>(null)
    const getProdcutInfo = () => {
        conmmonApi.getProdcutInfo(
            {},
            (resp: any) => {
                setProductInfo(resp.data)
            },
            (error: any) => {
                console.log(error)
            },
        )
    }

    useEffect(() => {
        getProdcutInfo()
    }, [])
    return (
        <div>
            <div className="self-start sticky top-0 z-20">
                <Header />

                <div className="px-[0.4rem] border-b-2 border-primary bg-[#f1f1f1]">
                    <div className="flex items-end h-[2.3rem] gap-2">
                        <DashboardTabElement label={t('My Experiments')} to={URLS.MY_EXPERIMENTS} active={active == 'my-experiment'} onClick={() => trackEvent('nav_tab_clicked', { tab: 'my_experiments' })} />
                        <DashboardTabElement label={t('Data Onboarding')} to={URLS.DATA_ONBOARDING} active={active == 'data-onboarding'} onClick={() => trackEvent('nav_tab_clicked', { tab: 'data_onboarding' })} />
                        <DashboardTabElement
                            label={t('Executive Dashboard')}
                            onClick={() => {
                                trackEvent('exec_dashboard_clicked')
                                trackEvent('nav_tab_clicked', { tab: 'executive_dashboard' })
                            }}
                            to={URLS.EXECUTIVE_DASHBOARD}
                            active={active == 'executive-dashboard'}
                        />
                        <DashboardTabElement label={t('Sample Size Estimator')} to={URLS.SAMPLE_SIZE} active={active == 'sample-size'} onClick={() => trackEvent('nav_tab_clicked', { tab: 'sample_size' })} />
                        <DashboardTabElement
                            label={t('Learning & Documentation')}
                            onClick={(e: any) => {
                                e.preventDefault()
                                e.stopPropagation()
                                trackEvent('nav_tab_clicked', { tab: 'glossary' })
                                globalThis.open(productInfo?.app_glossary_page)
                                return false
                            }}
                            to={productInfo?.app_glossary_page}
                            active={active == 'glossary'}
                        />
                    </div>
                </div>
            </div>
            <div style={{ minHeight: 'calc(100vh - 8.41rem)' }} className={className}>
                {children}
            </div>
            <Footer />
        </div>
    )
}

export default DashboardLayout
